<template>
    <div class="content">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="基本信息" name="1">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="合同号">
                            <div class="rows">{{ result.Orders_SN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="下单时间">
                            <div class="rows">{{ result.Orders_Addtime | formatDate }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="审核状态">
                            <div :class="judgeColor(result.Orders_AuditStatus)">{{ result.Orders_AuditStatus }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="办事处">{{ result.Office_Name }}</el-descriptions-item>
                        <el-descriptions-item label="业务员">{{ result.Orders_OfficeMan }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ result.Orders_ProjectName }}</el-descriptions-item>
                        <el-descriptions-item label="工程地址">{{ result.Orders_ProjectAddress }}</el-descriptions-item>
                        <el-descriptions-item label="特价申请已获批">{{ result.Orders_IsSpecialPriceAudit }}</el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="原订单信息" name="2">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="原ERP单号">{{ result.Orders_SourceERPSN }}</el-descriptions-item>
                        <el-descriptions-item label="原订单金额">{{ result.Orders_SourceOrdersAmount }}</el-descriptions-item>
                        <el-descriptions-item label="原业务员">{{ result.Orders_SourceOfficeManName + '[' + result.Orders_SourceOfficeManCode + ']' }}</el-descriptions-item>
                        <el-descriptions-item label="原合同纸号">{{ result.Orders_PaperContractSN }}</el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="客户信息" name="4">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="客户编码">
                            <div class="rows">{{ result.Orders_CustomerCode }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户名称">
                            <div class="rows">{{ result.Orders_CustomerName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户姓名" v-if="result.Orders_CustomerSubID > 0">
                            <div class="rows">{{ customerSubInfo.Customer_Sub_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="会员昵称">
                            <div class="rows">{{ result.Member_NickName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="真实姓名">
                            <div class="rows">{{ result.Member_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="固定电话">
                            <div class="rows">{{ result.Member_Phone_Number }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="性别">
                            <div class="rows">{{ result.Member_Sex }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="手机">
                            <div class="rows">{{ result.Member_Mobile }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="Email">
                            <div class="rows">{{ result.Member_Email }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="地址">
                            <div class="rows">{{ result.Member_StreetAddress }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="邮编">
                            <div class="rows">{{ result.Member_Zip }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="客户联系人" name="6">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="联系人	">
                            <div class="rows">{{ result.Orders_Contract_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系电话">
                            <div class="rows">{{ result.Orders_Contract_Mobile }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人Email">
                            {{ result.Orders_Contract_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="电子签章" name="7" v-if="result.IsBestSign">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="电子签章">
                            <div class="rows">
                                <el-radio v-model="Orders_ESignStatus" label="1">不使用</el-radio>
                                <el-radio v-model="Orders_ESignStatus" label="2">使用</el-radio>
                                <el-tag type="success" class="ml10" v-if="result.Customer_IsESign == 1">已注册电子签章</el-tag>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人姓名">
                            <div class="rows" v-if="result.Customer_Type == 1">{{ Orders_ESignName }}</div>
                            <div class="rows" v-else>
                                <el-input v-model="Orders_ESignName" placeholder="请输入联系人姓名"></el-input>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人手机">
                            <div class="rows" v-if="result.Customer_Type == 1">{{ Orders_EsignMobile }}</div>
                            <div class="rows" v-else>
                                <el-input v-model="Orders_EsignMobile" placeholder="请输入联系人手机"></el-input>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="是否开具红冲发票" name="8" v-if="this.Show_CreditInvoiceStatus">
                    <el-checkbox-group v-model="Orders_CreditInvoiceStatus">
                        <el-checkbox :label="1"><span class="fw700" style="color: red">开具红冲发票</span></el-checkbox>
                    </el-checkbox-group>
                </el-collapse-item>
                <el-collapse-item title="退货清单" name="9">
                    <el-checkbox-group v-model="Orders_ReturnCommitment">
                        <el-checkbox :label="1"><span class="fw700" style="color: red">退货承诺：本次退货设备已核验完毕，不影响二次销售</span></el-checkbox>
                    </el-checkbox-group>
                    <el-table :data="returnsList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="Goods_Product_Code" label="商品编码" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="原始价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_SourcePrice, 2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Price" label="申请价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_Price, 2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Amount" label="数量" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="合计" align="center">
                            <template v-slot="scope">
                                <div class="is-status-text">
                                    {{ getFloat(Number((scope.row.Goods_Product_Price * scope.row.Goods_Product_Amount).toFixed(2))) }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                        合计： ￥
                        <span class="is-status-text">{{ getFloat(returnGoodesPorductPirce) }}</span>
                    </div>
                </el-collapse-item>
            </el-collapse>

            <div class="button-container">
                <el-button type="primary" @click="submit">提交合同</el-button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'returnSubmitOrder',
    props: {
        submitOrderData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            activeNames: ['1', '2', '4', '6', '7', '8', '9'],
            id: 0,
            result: {
                Orders_Account_Pay: '',
                Orders_Address_City: '',
                Orders_Address_Country: '',
                Orders_Address_County: '',
                Orders_Address_ID: '',
                Orders_Address_Mobile: '',
                Orders_Address_Name: '',
                Orders_Address_Phone_Areacode: '',
                Orders_Address_Phone_Countrycode: '',
                Orders_Address_Phone_Number: '',
                Orders_Address_State: '',
                Orders_Address_StreetAddress: '',
                Orders_Address_Type: '',
                Orders_Address_Zip: '',
                Orders_Addtime: '',
                Orders_Admin_Note: '',
                Orders_Admin_Sign: '',
                Orders_Attachment: '',
                Orders_AttachmentAudit: '',
                Orders_AttachmentAudit_Time: '',
                Orders_AuditStatus: '',
                Orders_AuditTime: '',
                Orders_AuditorID: '',
                Orders_AuditorSort: '',
                Orders_AuthorizeCode: '',
                Orders_BPMAuditStatus: '',
                Orders_BPMBizObjectID: '',
                Orders_BreakResponsibility: '',
                Orders_BuyerID: '',
                Orders_CashOutputStatus: '',
                Orders_CoinbuyNotifyStatus: '',
                Orders_Contract_Email: '',
                Orders_Contract_Mobile: '',
                Orders_Contract_Name: '',
                Orders_CustomerCode: '',
                Orders_CustomerID: '',
                Orders_CustomerMobile: '',
                Orders_CustomerName: '',
                Orders_CustomerPartA: '',
                Orders_CustomerSubID: '',
                Orders_Delivery: '',
                Orders_DeliveryStatus: '',
                Orders_DeliveryStatus_Time: '',
                Orders_DeliveryTime: '',
                Orders_Delivery_Name: '',
                Orders_DiscountCate: '',
                Orders_DiscountRate: '',
                Orders_DistrictCode: '',
                Orders_ERPDepotID: '',
                Orders_ERPSN: '',
                Orders_ERPSyncStatus: '',
                Orders_Fail_Addtime: '',
                Orders_Fail_Note: '',
                Orders_Fail_SysUserID: '',
                Orders_FreightType: '',
                Orders_From: '',
                Orders_GatheringDefault: '',
                Orders_GroupOrdersID: '',
                Orders_ID: '',
                Orders_InvoiceCode: '',
                Orders_InvoiceOutputStatus: '',
                Orders_InvoiceOutputStatus_Time: '',
                Orders_InvoiceStatus: '',
                Orders_IsAllDelivery: '',
                Orders_IsAllDeliveryApply: '',
                Orders_IsAllFreight: '',
                Orders_IsAllReach: '',
                Orders_IsAreaSpan: '',
                Orders_IsEvaluate: '',
                Orders_IsNoCustomerSign: '',
                Orders_IsPayAuditDelivery: '',
                Orders_IsReturnCoin: '',
                Orders_IsShortStock: '',
                Orders_IsSpecialPriceAudit: '',
                Orders_MarketCode: '',
                Orders_MsgNotify: '',
                Orders_MsgNotifyEnable: '',
                Orders_MsgNotifyStatus: '',
                Orders_NextPay_Days: '',
                Orders_Note: '',
                Orders_OfficeCode: '',
                Orders_OfficeID: '',
                Orders_OfficeManCode: '',
                Orders_OfficeManID: '',
                Orders_OtherAgreement: '',
                Orders_PayType: '',
                Orders_PayType_Name: '',
                Orders_PayType_Sign: '',
                Orders_PaymentNotifyNum: '',
                Orders_PaymentNotifyTime: '',
                Orders_PaymentReceiptType: '',
                Orders_PaymentStatus: '',
                Orders_PaymentStatus_Time: '',
                Orders_Payway: '',
                Orders_Payway_Name: '',
                Orders_PrePay_Percent: '',
                Orders_PriceListERPCode: '',
                Orders_PriceListID: '',
                Orders_PriceListType: '',
                Orders_ProjectAddress: '',
                Orders_ProjectCity: '',
                Orders_ProjectCountry: '',
                Orders_ProjectCounty: '',
                Orders_ProjectName: '',
                Orders_ProjectNote: '',
                Orders_ProjectState: '',
                Orders_ProjectType: '',
                Orders_ProjectType_Code: '',
                Orders_ProjectType_ID: '',
                Orders_ProjectType_Name: '',
                Orders_RecoverStatus: '',
                Orders_RequestBillsStatus: '',
                Orders_SN: '',
                Orders_SPCOrdersID: '',
                Orders_SPCSN: '',
                Orders_ShortStock_Note: '',
                Orders_ShortStock_Status: '',
                Orders_Site: '',
                Orders_Source: '',
                Orders_SourceType: '',
                Orders_Status: '',
                Orders_SyncStatus: '',
                Orders_SyncTime: '',
                Orders_SysUserID: '',
                Orders_TMALLSN: '',
                Orders_Total_AllPrice: '',
                Orders_Total_Coin: '',
                Orders_Total_Freight: '',
                Orders_Total_FreightDiscount: '',
                Orders_Total_FreightDiscount_Note: '',
                Orders_Total_MKTPrice: '',
                Orders_Total_Price: '',
                Orders_Total_PriceDiscount: '',
                Orders_Total_PriceDiscount_Note: '',
                Orders_Total_UseCoin: '',
                Orders_VerifyCode: '',
                Orders_VirtualInvoiceCode: '',
                Orders_VirtualRegionID: '',
                Orders_WaitSignStatus: '',
                Orders_WaitSignTime: '',
                Orders_Warranty: ''
            },

            Member: {
                Member_NickName: ''
            },

            orderList: [
                { title: '订单号', value: '' },
                { title: '订单状态', value: '' },
                { title: '下单时间', value: '' }
            ],
            Orders_SPCOrdersDetails: {}, //关联合同详情
            allStatus: {
                auditStatus: '', //审核状态
                ordersBPMAuditStatus: '', //BPM审核状态
                ordersContractReceive: '', //合同纸回收状态
                ordersESignStatus: '' //电子签章状态
            },
            officemanInfo: {}, //业务员信息
            ordersProjectTypeStatus: '', //项目类型
            ProjectType_name: '', //行业类型
            cabinetSupplier: '', //配电柜厂家
            changeReason: '', //地址变更原因
            payMentDetails: [], //付款方式
            customerSubInfo: '', //二级客户信息
            customerInfo: '', //二级客户信息
            memberInfo: { MemberProfileInfo: '' }, //会员信息
            batchButtonList: [], //关联订单批量操作按钮
            SPCOrdersRelateList: [], //关联订单列表
            BatchOrderId: [], //批量操作订单ID
            distributeList: [], //业绩分配比例

            buttonList: [], //订单详情按钮
            payMentsHistoryList: [], //合同付款记录
            PayDistributeList: [], //合同付款分配
            DeliveryApplyList: [], //临时发货申请
            applyDiscountData: [], //折扣分组
            GoodsList: [], //商品清单
            auditLise: [], //审核说明
            ordersLogsList: [], //合同日志
            Orders_ESignStatus: '', // 电子签章状态
            Orders_ESignName: '', //签章姓名
            Orders_EsignMobile: '', //签章联系人
            performanceList: [], //业绩分配比例
            multipleSelection: [], // 多选业绩分配
            needOrderInfo: {}, // 提交订单需要的参数
            Orders_IsAllReach: 0, // 是否在付款审核通过后立即发货
            Orders_IsAllReachShow: false, // 是否在付款审核通过后立即发货
            relation: 0, // 关联订单
            addrchangereason: '', // 地址变更原因
            performance_note: '', // 业绩划分备注
            Orders_CreditInvoiceStatus: false, //是否开具红冲发票
            Show_CreditInvoiceStatus: false, //是否展示开具红冲发票
            returnsList: [], //退款清单
            Orders_ReturnCommitment: false, //退货承诺
            returnGoodesPorductPirce: 0 //退货清单总金额
        };
    },
    mounted() {
        const id = this.submitOrderData.id;
        const relation = this.submitOrderData.relation;
        console.log(id, 'idid');
        if (id) {
            this.id = id;
            this.relation = relation;
            this.GetSPCOrdersByID(this.id, relation);
        }
    },
    methods: {
        cellStyle() {
            return { padding: '0' }; // 去除单元格内边距
        },

        async GetSPCOrdersByID(id, relation) {
            const orderID = id; // Example order ID
            let json = JSON.stringify({ relation: relation || 0 });
            let loadingInstance = this.$loading(); // 显示 loading
            const result = await this.$newsApi.contract.CheckSPCOrdersConfirm({
                OrdersID: orderID,
                Json: json
            });
              
            if (result.data.Resultcode == 1) {
                this.$message({
                    message: result.Resultinfo,
                    type: 'warning'
                });
            }
            this.$closeLoading(loadingInstance); // 关闭 loading
            this.result = result.data.data;
            this.payMentDetails = result.data.data.Payment;
            this.Orders_ESignName = this.result.Orders_Contract_Name;
            this.Orders_EsignMobile = this.result.Orders_Contract_Mobile;
            this.returnsList = this.result.BackGoodList;
            this.Show_CreditInvoiceStatus = this.result.CheckInvoice;
            this.Orders_CreditInvoiceStatus = this.result.Orders_CreditInvoiceStatus == 1 ? true : false;
            this.Orders_ReturnCommitment = this.result.Orders_IsEvaluate == 1 ? true : false;
            this.returnGoodesPirce();
        },
        //计算退货商品总价
        returnGoodesPirce() {
            this.returnGoodesPorductPirce = 0;
            this.returnsList.forEach((item, index) => {
                this.returnGoodesPorductPirce += Number((item.Goods_Product_Price * item.Goods_Product_Amount).toFixed(2));
            });
            this.returnGoodesPorductPirce = this.returnGoodesPorductPirce.toFixed(2);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 禁用所有复选框，使其不可修改
        selectable(row, index) {
            // 如果只想让第一行不可修改，可以返回 true 只有对第一行进行限制
            return index !== 0; // 使第一行不可取消选中
        },
        // 提交合同
        submit() {
            // 提取购物车折扣价参数
            var list = this.result.SPCGoodList;
            var obj = {};
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].Goods.length; j++) {
                    obj['FreightAmount_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_DeliveryAmount; //批量发货数量
                }
            }
            // 将obj合并到 orderInfo里面
            for (var key in obj) {
                this.needOrderInfo[key] = obj[key];
            }
            // 提取业绩划分参数
            var ListTwo = this.multipleSelection;
            var objTwo = {};
            objTwo.POffice_ID = this.multipleSelection
                .map((item) => {
                    return item.OfficeID;
                })
                .join();
            for (let i = 0; i < ListTwo.length; i++) {
                objTwo['performance_' + ListTwo[i].OfficeID] = ListTwo[i].Rate || 0;
                objTwo['Poffice_ManID_' + ListTwo[i].OfficeID] = ListTwo[i].OfficeMemberID;
            }
            // 将objTwo合并到 orderInfo里面
            for (var key in objTwo) {
                this.needOrderInfo[key] = objTwo[key];
            }
            // 将业绩划分备注合并
            this.needOrderInfo.performance_note = this.performance_note;
            // 是否在付款审核通过后立即发货
            this.needOrderInfo.Orders_IsPayAuditDelivery = this.Orders_IsAllReach;
            // 地址变更原因
            this.needOrderInfo.addrchangereason = this.addrchangereason;

            this.needOrderInfo.relation = this.relation;
            this.needOrderInfo.Orders_CreditInvoiceStatus = this.Orders_CreditInvoiceStatus ? 1 : 0;
            this.needOrderInfo.Orders_ReturnCommitment = this.Orders_ReturnCommitment ? 1 : 0;
            this.needOrderInfo.Show_CreditInvoiceStatus = this.Show_CreditInvoiceStatus ? 1 : 0;
            // 电子签章
            this.needOrderInfo.Orders_ESignStatus = this.Orders_ESignStatus;
            this.needOrderInfo.Orders_ESignName = this.Orders_ESignName;
            this.needOrderInfo.Orders_EsignMobile = this.Orders_EsignMobile;
            this.needOrderInfo.Customer_IsESign = this.result.IsBestSign ? 1 : 0;
            this.confirmOrder();
        },
        // 确认提交订单
        async confirmOrder() {
            console.log(this.needOrderInfo);
            var Json = JSON.stringify(this.needOrderInfo);
            let loadingInstance = this.$loading(); // 显示 loading
            const res = await this.$newsApi.contract.SPCOrders_Submit({
                OrdersID: this.result.Orders_ID,
                SourceType: 'PC',
                Json: Json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (res.data.Resultcode == 0) {
                this.$emit('submitOrderComplete');
                // this.$router.push({ path: '/contractreturnManagement/index?t=' + Date.now() });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.centered-select /deep/.el-input__inner {
    text-align: center;
}

.centered-select /deep/.el-select-dropdown__item {
    text-align: center;
}
.button-container {
    text-align: center;
    margin-top: 20px;
}
</style>